import * as THREE from "three";
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import {Group} from "three";
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';

export default class DtElement extends Group {
    hasBeenLoaded = false;

    constructor(element, dimensions, dracoLoader) {
        super();
        this.fbxLoader = new FBXLoader();
        const manager = new THREE.LoadingManager();
        this.gltfLoader = new GLTFLoader(manager);
        this.gltfLoader.setDRACOLoader(dracoLoader);
        const mainJson = element.main;
        this.loadObject(this.getFileName(mainJson), mainJson, dimensions, element.attributes);
    }

    loadObject(fileName, element, dimensions, attributes) {
        const url = `/elements/${element.folder}/3D/gltf/${fileName}_out/${fileName}.gltf`;
        this.gltfLoader.load(
            url,
            (object) => {
                object = this.fixColorSpacing(object);

                const boundingBox = new THREE.Box3();

                // calculate scale
                boundingBox.setFromObject(object);
                const initialSize = new THREE.Vector3();
                boundingBox.getSize(initialSize);
                const scale = element.width / initialSize.x;
                object.scale.set(scale, scale, scale);

                // reposition object to root
                boundingBox.setFromObject(object);
                object.rotateX(THREE.MathUtils.degToRad(90));
                object.rotateY(THREE.MathUtils.degToRad(180));

                const middle = new THREE.Vector3();
                boundingBox.getCenter(middle);
                const size = new THREE.Vector3();
                boundingBox.getSize(size);

                object.translateX(-middle.x - size.x/2);
                object.translateY(-middle.y + size.y/2);
                object.translateZ(-middle.z + size.z/2);

                let positionedElement = new THREE.Group();
                positionedElement.add(object);
                // reposition object on canvas
                positionedElement.translateX(element.left);
                let objectDifference = size.z - element.height;

                if(this.elementHasWire(attributes)) {
                    objectDifference = 0;
                }
                positionedElement.translateY(dimensions.height - element.top - element.height - objectDifference);

                let attributeDistancePassThrough = null;
                if (element.depth) {
                    positionedElement.translateZ(element.depth);
                    attributeDistancePassThrough = element.depth;
                } else if(element?.["distance-from-wall"]) {
                    let distanceFromWall = element["distance-from-wall"];
                    if(typeof distanceFromWall === "string") {
                        distanceFromWall = Number(distanceFromWall.replace("px", ""));
                    }
                    positionedElement.translateZ(distanceFromWall);
                    attributeDistancePassThrough = distanceFromWall;
                }

                if(element.upsidedown) {
                    positionedElement.rotateZ(THREE.MathUtils.degToRad(180));
                    positionedElement.translateY(-element.height - element.height - objectDifference);
                    positionedElement.translateX(-element.width);
                }

                this.add(positionedElement);

                if (element.selectedGrip && attributes.length > 0) {
                    attributes
                        .forEach((attribute) => {
                            if('top' in attribute) {
                                attribute.top += element.top + objectDifference;
                            } else if('bottom' in attribute) {
                                attribute.top = element.top + element.height + objectDifference - attribute.bottom;
                            }

                            attribute.left += element.left;

                            attribute.depth = size.y;
                            if (attribute.sku.toString().startsWith('M')) {
                                attribute.depth -= 4.5;
                            }

                            if(attributeDistancePassThrough) {
                                attribute.depth += attributeDistancePassThrough;
                            }

                            this.loadObject(this.getFileName(attribute), attribute, dimensions, [], true);
                        });
                }

                // this.add(object);
                this.hasBeenLoaded = true;
            },
            (xhr) => {
                //console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
            },
            (error) => {
                this.hasBeenLoaded = true;
                console.log(error, element);
            }
        )
    }

    getFileName(elementJson) {
        return elementJson.threeD.replace(".fbx", "");
    }

    enableCastShadow(object) {
        object.castShadow = true;
        if (object.children) {
            object.children.forEach(this.enableCastShadow.bind(this));
        }
    }

    elementHasWire(elementAttributes) {
        let hasWire = false;

        for(const attribute of elementAttributes) {
            if(attribute.type === "wire") {
                hasWire = true;
                break;
            }
        }

        return hasWire;
    }

    fixColorSpacing(object) {
        object.scene.traverse((o) => {
            if (o.isMesh) {
                o.material.metalness = 0;
                if(o.material.map) {
                    o.material.map.colorSpace = THREE.LinearSRGBColorSpace;
                }
            }
        });

        object = object.scene;

        this.enableCastShadow(object);

        return object;
    }
}